import { render, staticRenderFns } from "./PlantTable.vue?vue&type=template&id=1bc072e0&"
import script from "./PlantTable.vue?vue&type=script&lang=ts&"
export * from "./PlantTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports